import {ReactElement} from "react";
import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {DIVIDER, PD_XLG, PD_XLG2} from "@/shared/dimens";
import {Typography} from "@mui/material";
import {getMyLabelerTeamMemberId, LabelerTask, LabelerTasks, ResourceData} from "../../fyneai-shared/types";
import {LabelerTasksListView} from "./LabelerTasksListView";
import {LabelerTaskSelectView} from "./LabelerTaskSelectView";

export type DashboardFragmentProps = PageFragmentProps & {}

type DashboardFragmentState = PageFragmentState & {
  tasks: LabelerTask[],
  selectedTask: LabelerTask,
  setSelectedTask: (task: LabelerTask) => void,
}

export class DashboardFragment extends PageFragment<DashboardFragmentProps, DashboardFragmentState> {

  protected getTitle(): string | null | undefined {
    return "Dashboard";
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    const teamMemberId = getMyLabelerTeamMemberId();
    const assignments = await ResourceData.project().labeler.assignments.loadAssignmentsByTeamMemberId(teamMemberId);
    const tasks: LabelerTask[] = [];
    for (const assignment of assignments) {
      if (assignment.teamMemberId !== teamMemberId) {
        continue;
      }
      const task = await new LabelerTasks(ResourceData.projectId(), assignment.datasetId).loadListItem(assignment.taskId);
      if (task) {
        tasks.push(task);
      }
    }
    this.setState({
      tasks,
    });
  }

  renderContent(): ReactElement {
    return <>
      <StyledBoxColumn
        style={{
          padding: `${PD_XLG2}px ${PD_XLG}px`,
          background: this.theme.palette.background.paper,
          borderBottom: DIVIDER
        }}>
        <Typography variant={"h4"}>Welcome to Labeler</Typography>
        <Typography>Use your expertise to help train ML & AI models.</Typography>
      </StyledBoxColumn>
      <StyledBoxColumn style={{padding: PD_XLG, gap: PD_XLG}}>
        <StyledBoxColumn>
          <Typography variant={"h5"}>Tasks</Typography>
          <LabelerTaskSelectView
            path={this.props.path}
            tasks={this.state.tasks}
            selectedTask={this.state.selectedTask}
            setSelectedTask={selectedTask => this.setState({selectedTask})}/>
        </StyledBoxColumn>
      </StyledBoxColumn>
    </>;
  }
}